import {
    Button,
    Card,
    CardContent,
    CardHeader,
    CircularProgress,
    Grid,
    List,
    ListItem,
    ListItemText,
    TextField,
    Typography,
} from "@mui/material";
import { Formik } from "formik";
import { useState } from "react";
import { useLoaderData, useNavigate, useParams } from "react-router-dom";
import { wrapFormikHandleChange } from "../../../../infrastructure/utils/formatters";

import { toast } from "react-toastify";
import * as Yup from "yup";
import { toJalaliFullDate } from "../../../middleware/middleware";

import DefaultApiService from "../../../../infrastructure/api/default";
import BreadcrumbsComponent from "../../../components/shared/breadcrumbs";

const validationSchema = Yup.object().shape({
  comment: Yup.string().required("لطفا این فیلد را پر کنید."),
});

const TicketViewModifyPage = () => {
  const data = useLoaderData("root");
  let navigate = useNavigate();
  const { id: roleId } = useParams();

  const [loading, setLoading] = useState(false);

  const onNavigateToListPage = () => {
    navigate("/UM/Yeksa/Ticket");
  };

  const onSubmit = async (formValue) => {
    setLoading(true);
    const sendData = {
      TicketId: data.ticket.id,
      Comment: formValue.comment,
    };

    try {
      const res = await DefaultApiService.postApi(
        "UM/Ticket/Response",
        sendData
      );

      if (res.isSuccess) {
        toast.success(res.message);
        onNavigateToListPage();
      } else {
        toast.error(res.message);
      }

      setLoading(false);
    } catch (error) {
      toast.error(error?.response?.data?.message || "خطایی رخ داده است.");
      setLoading(false);
    }
  };



  
  const onClose = async (formValue) => {
    setLoading(true);
    const sendData = {
      TicketId: data.ticket.id,
      Comment: formValue.comment,
    };

    try {
      const res = await DefaultApiService.postApi(
        "TCK/User/Ticket/Close",
        sendData
      );

      if (res.isSuccess) {
        toast.success(res.message);
        onNavigateToListPage();
      } else {
        toast.error(res.message);
      }

      setLoading(false);
    } catch (error) {
      toast.error(error?.response?.data?.message || "خطایی رخ داده است.");
      setLoading(false);
    }
  };

  return (
    <Grid container spacing={3}>
      <Grid item xs={12} md={12}>
        <BreadcrumbsComponent />
      </Grid>

      <Grid item xs={12} md={12}>
        <Card>
          <CardHeader
            title={`مشاهده تیکت: ${data?.ticket?.title}`}
          />
          <CardContent>
            <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
                <Typography variant="body1"><strong>کاربر:</strong> {data.ticket.userTitle}</Typography>
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography variant="body1"><strong>عنوان:</strong> {data.ticket.title}</Typography>
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography variant="body1"><strong>گروه:</strong> {data.ticket.categoryTitle}</Typography>
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography variant="body1"><strong>اولویت:</strong> {data.ticket.ticketPriority}</Typography>
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography variant="body1"><strong>وضعیت:</strong> {data.ticket.ticketStatus}</Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography variant="body1"><strong>محتوا:</strong></Typography>
                <div dangerouslySetInnerHTML={{ __html: data.ticket.content }} />
              </Grid>
            </Grid>
            <Typography variant="h6" sx={{ mt: 3 }}>تاریخچه تیکت</Typography>
            <List>
              {data.histories.map(history => (
                <ListItem key={history.id}>
                  <ListItemText
                    primary={history.title}
                    secondary={
                      <>
                        <Typography variant="body2" color="textPrimary">
                          {history.userTitle} - {toJalaliFullDate(history.updateOn)}
                        </Typography>
                        <Typography variant="body2">{history.comment}</Typography>
                      </>
                    }
                  />
                </ListItem>
              ))}
            </List>
            <Formik
              initialValues={{
                comment: ''
              }}
              validationSchema={validationSchema}
              onSubmit={(values, { setSubmitting }) => {
                onSubmit(values);
                setSubmitting(false);
              }}
            >
              {({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                isSubmitting,
              }) => (
                <form onSubmit={handleSubmit}>
                  <Grid container spacing={3}>
                    <Grid item xs={12}>
                      <TextField
                        label="توضیحات"
                        multiline
                        rows={4}
                        name="comment"
                        fullWidth
                        variant="outlined"
                        value={values.comment}
                        onChange={wrapFormikHandleChange(handleChange)}
                        onBlur={handleBlur}
                        error={errors.comment && touched.comment}
                        helperText={errors.comment && touched.comment && errors.comment}
                      />
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      md={12}
                      container
                      justifyContent={"flex-end"}
                    >
                      <Button
                        disabled={isSubmitting}
                        variant="outlined"
                        size="large"
                        color="gray"
                        sx={{ mx: 1 }}
                        onClick={onNavigateToListPage}
                      >
                        انصراف
                      </Button>
                      <Button
                        disabled={isSubmitting}
                        variant="outlined"
                        size="large"
                        color="gray"
                        sx={{ mx: 1 }}
                        onClick={onClose}
                      >
                        بستن تیکت
                      </Button>

                      <Button
                        disabled={isSubmitting}
                        variant="contained"
                        type="submit"
                        size="large"
                      >
                        {loading && (
                          <CircularProgress size={16} color="inherit" />
                        )}
                        پاسخ
                      </Button>
                    </Grid>
                  </Grid>
                </form>
              )}
            </Formik>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};

export default TicketViewModifyPage;
